{
  "services-mobile-top-ups": {
    "meta": {
      "title": "Recargas Movil Internacional  - Envia sin Costos Ocultos- MAJORITY",
      "description": "¿Está buscando como mandar recargas Internacioneles a tu Familia e amigos? ¡Envía recargas sin cargos ocultos. Descubre el app de MAJORITY."
    },
    "hero": {
      "title": "RECARGAS MÓVILES INTERNACIONALES",
      "body": "Envía recargas móviles a más de 35 países al instante",
      "cta": "Envío recargas a",
      "features": "Recargas móviles ilimitadas sin cargos\nEntrega instantánea y segura"
    },
    "unlimited_content_box": {
      "tagline": "Recargas móviles",
      "title": "Envía recargas móviles ilimitadas y sin cargos",
      "body": "Envía recargas móviles a tus seres queridos en casa sin gastar más en cargos extra. Envía tiempo aire a más de 35 países, incluidos Cuba, México, Nigeria, Colombia y más. Tus familiares y amigos pueden usar las recargas para llamar, enviar mensajes y navegar por internet."
    },
    "instant_content_box": {
      "tagline": "Recargas móviles",
      "title": "Entrega instantánea y segura",
      "body": "Las recargas móviles de MAJORITY son instantáneas y siempre se envían de forma segura. De esta forma, tu familia no estará esperando sus recargas para comunicarse contigo."
    },
    "faq": {
      "title": "Preguntas frecuentes",
      "faqs": [
        {
          "question": "¿Puedo usar MAJORITY si no soy un migrante?",
          "answer": "¡Sí! Todos son bienvenidos. Si alguna de las funciones de nuestra app te interesa, regístrate y pruébala."
        },
        {
          "question": "¿Es MAJORITY un banco?",
          "answer": "Somos una app de membresía financiera y Axiom Bank, N.A., miembro de la FDIC, brinda nuestros servicios financieros. Axiom Bank, N.A., también emite nuestra Tarjeta de débito MAJORITY Visa® conforme a una licencia de Visa U.S.A. Inc. ¡La tarjeta se puede utilizar en cualquier lugar donde se acepte Visa!"
        },
        {
          "question": "¿Qué es MAJORITY?",
          "answer": "MAJORITY es la primera membresía financiera desarrollada por migrantes, para migrantes. Después de registrarte, ¡recibes una cuenta asegurada por la FDIC sin cargos por sobregiro, una Tarjeta de Débito Visa®, envíos de dinero sin cargos, llamadas internacionales gratuitas y baratas, y más!"
        },
        {
          "question": "¿Dónde está MAJORITY?",
          "answer": "Tenemos oficinas en Houston, Miami y Estocolmo, Suecia. Visítanos en nuestro lugar de encuentro MAJORITY Meetup Houston, ubicado en 9801 V Bissonnet Street, Houston, Texas 77036, Estados Unidos."
        },
        {
          "question": "¿Estará seguro mi dinero con MAJORITY?",
          "answer": "Absolutamente. Tu cuenta MAJORITY está asegurada por la FDIC, así que no importa si estás en EE.UU. o en el extranjero, el dinero en tu cuenta está asegurado por la FDIC hasta por $250,000. Además, podrás acceder a la app desde cualquier parte del mundo, así que ¡no tienes de qué preocuparte."
        }
      ]
    }
  }
   
}